import { DefaultApiUrl } from "../constants/DefaultApiUrl";

export type ApiUrlOptions = {
  query?: string[][] | Record<string, string> | string | URLSearchParams;
};

export const useApiUrl = () => {
  const baseUrl = process.env.EXPO_PUBLIC_API_URL ?? DefaultApiUrl;
  return (value = "/", options: ApiUrlOptions = {}) => {
    const url = new URL(value, baseUrl);

    if (options.query) {
      const params = new URLSearchParams(url.search);

      for (const [name, value] of new URLSearchParams(
        options.query,
      ).entries()) {
        params.set(name, value);
      }

      url.search = params.toString();
    }

    return url.href;
  };
};
